import { render, staticRenderFns } from "./StudentSchedule.vue?vue&type=template&id=73fb1dae&scoped=true&lang=pug&"
import script from "./StudentSchedule.vue?vue&type=script&lang=ts&"
export * from "./StudentSchedule.vue?vue&type=script&lang=ts&"
import style0 from "./StudentSchedule.vue?vue&type=style&index=0&id=73fb1dae&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73fb1dae",
  null
  
)

export default component.exports